import { Text, TextStyle, TouchableOpacity, ViewStyle } from "react-native";
import { StyleProp } from "react-native/Libraries/StyleSheet/StyleSheet";
import { LayoutChangeEvent } from "react-native/Libraries/Types/CoreEventTypes";
import DebounceButton from "../screen/DebounceButton";

interface ButtonViewProps {
    style?: ViewStyle[] | ViewStyle,
    text: string,
    onPress?: () => void,
    textStyle?: StyleProp<TextStyle>
    onLayout?: (event: LayoutChangeEvent) => void
}

export const ButtonView = ({ style, text, onPress, textStyle, onLayout }: ButtonViewProps) => {
    return (<DebounceButton
        onLayout={onLayout}
        debounceTime={1000}
        activeOpacity={1}
        onPress={onPress} style={style}>
        <Text numberOfLines={1} ellipsizeMode={"tail"} style={textStyle}>{text}</Text>
    </DebounceButton>);
};
